import { PageDefaultSegment } from "@sis/react-library";
import { Box } from "@mui/material";

interface FormSamplesOutputProps {
    submittedValues: object | undefined;
    width?: string | number;
}

export const FormSamplesOutput = ({
    submittedValues, width
}: FormSamplesOutputProps) => {

    return (
        <>
            {submittedValues &&
                <Box sx={{ marginTop: 4 }}>
                    <PageDefaultSegment width={width}>
                        <h5
                            style={{ margin: '0 0 10px 0' }}
                        >
                            Submitted Output
                        </h5>
                        <textarea
                            value={JSON.stringify(submittedValues, undefined, 2)}
                            readOnly
                            style={{
                                width: '100%',
                                height: '200px'
                            }}
                        />
                    </PageDefaultSegment>
                </Box>
            }
        </>
    )
}
